// extracted by css-extract-rspack-plugin
var _1 = "iu";
var _2 = "e0";
export { _1 as "browserSupport", _2 as "title" }
